import React from 'react';
import { object, number, func } from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from '@fiverr-private/fiverr_context';
import { Icon, Tooltip } from '@fiverr-private/fit';
import { l_times, s_question_circle } from '@fiverr-private/icons';
import { getPackageById } from '../../../../reducers/packages';
import { calcServiceFee } from '../../../../utils/serviceFee';

import './style.scss';

export const PriceSummaryContent = ({ currentPrice, close }, { currencyConverter }) => {
    const subtotalPrice = currencyConverter.convert(currentPrice);
    const serviceFee = currencyConverter.convert(calcServiceFee(currentPrice));
    const totalPrice = currencyConverter.convertWithFee(currentPrice);

    const handleCloseIconClick = (e) => {
        e.preventDefault();
        close(e);
    };

    return (
        <div className="price-summary-content">
            <Icon size={12} className="close-icon-btn" onClick={handleCloseIconClick}>{l_times}</Icon>
            <header>
                <h1><I18n k="gig_page_perseus.price_summary_popover.header"/></h1>
            </header>
            <div className="row">
                <div className="label-wrapper">
                    <span className="label"><I18n k="gig_page_perseus.price_summary_popover.subtotal"/></span>
                </div>
                <span className="value">{subtotalPrice}</span>
            </div>
            <div className="row">
                <div className="label-wrapper">
                    <span className="label"><I18n k="gig_page_perseus.price_summary_popover.service_fee"/></span>
                    <Tooltip className="price-summary-tooltip" content={<I18n k="gig_page_perseus.price_summary_popover.tooltip"/>}>
                        <Icon size={12} className="tooltip-icon icon-medium">{s_question_circle}</Icon>
                    </Tooltip>
                </div>
                <span className="value">{serviceFee}</span>
            </div>
            <hr className="separator"/>
            <footer>
                <span><I18n k="gig_page_perseus.price_summary_popover.total"/></span>
                <span>{totalPrice}</span>
            </footer>
        </div>
    );
};

PriceSummaryContent.propTypes = {
    currentPrice: number.isRequired,
    close: func.isRequired
};

PriceSummaryContent.contextTypes = {
    currencyConverter: object
};

const mapStateToProps = ({ packages }, ownProps) => {
    const packageData = getPackageById(packages, ownProps.packageId);

    return {
        currentPrice: packageData.currentPrice
    };
};

export default connect(mapStateToProps, null)(PriceSummaryContent);
